// client/components/profil/SmallPasskeyButton.jsx
import React, { useEffect, useRef, useState } from "react";
import { showSuccess, showError } from "../../utils/toast.js";
import { registerPasskey, isPasskeyAvailable, hasLocalPasskeyInstalled, markLocalPasskeyInstalled } from "../../constants/passkeys";
import AppButton from "../ui/AppButton.jsx";
import { detailPageHeaderNavClassName } from "../../design/tokens.js";
import { cn } from "../../utils/themeClasses.js";

// ——— Cookie-Helper ———
function setPasskeyCookie() {
  try {
    document.cookie = "wrtk_passkey_installed=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure";
  } catch {}
}
function hasPasskeyCookie() {
  try {
    return document.cookie.split(";").some(c => c.trim().startsWith("wrtk_passkey_installed="));
  } catch {
    return false;
  }
}

/**
 * Props:
 *  - onDone?: () => void   // optional callback nach erfolgreicher Registrierung
 */
export default function SmallPasskeyButton({
  onDone,
  variant = "pill"
}) {
    const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    (async () => {
      try {
        const supported = await isPasskeyAvailable();
        if (!supported) return;
        const hasLocal = hasLocalPasskeyInstalled() || hasPasskeyCookie();
        if (mounted.current) setReady(!hasLocal);
      } catch (e) {
        console.warn("[Passkey] init failed", e);
      }
    })();
    return () => {
      mounted.current = false;
    };
  }, []);
  async function handleClick() {
    if (busy) return;
    try {
      setBusy(true);
      const fin = await registerPasskey(); // setzt intern markLocalPasskeyInstalled()
      if (fin?.erfolg) {
        // Fallback, falls registerPasskey mal nicht markiert:
        try {
          markLocalPasskeyInstalled();
        } catch {}
        setPasskeyCookie();
        showSuccess("Passkey auf diesem Gerät eingerichtet");
        setReady(false);
        onDone?.();
      } else {
        showError(fin?.msg || "Konnte nicht eingerichtet werden");
      }
    } catch (e) {
      showError(e, {
        fallbackKey: "Abgebrochen"
      });
    } finally {
      if (mounted.current) setBusy(false);
    }
  }
  if (!ready) return null;
  const common = {
    onClick: handleClick,
    disabled: busy,
    title: "Passkey auf diesem Gerät einrichten",
    "aria-busy": busy,
    "data-testid": "btn-passkey-setup"
  };
  const btnCls = cn("shrink-0", detailPageHeaderNavClassName);
  if (variant === "icon") {
    return (
      <AppButton type="button" variant="secondary" size="lg" {...common} className={btnCls} aria-label="Passkey einrichten">
        {busy ? "…" : "Passkey"}
      </AppButton>
    );
  }
  return (
    <AppButton type="button" variant="secondary" size="lg" {...common} className={btnCls}>
      {busy ? "Einrichten…" : "Passkey einrichten"}
    </AppButton>
  );
}